// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { ICarrierConfigResponseAggregatorDto } from './ICarrierConfigResponseAggregatorDto';
import {
    ICarrierConfigResponseAggregatorDtoFromJSON,
    ICarrierConfigResponseAggregatorDtoFromJSONTyped,
    ICarrierConfigResponseAggregatorDtoToJSON,
    ICarrierConfigResponseAggregatorDtoToJSONTyped,
} from './ICarrierConfigResponseAggregatorDto';

/**
 * 
 * @export
 * @interface ICarrierConfigResponseAggregatorDtoPage
 */
export interface ICarrierConfigResponseAggregatorDtoPage {
    /**
     * 
     * @type {number}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<ICarrierConfigResponseAggregatorDto>}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    content?: Array<ICarrierConfigResponseAggregatorDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICarrierConfigResponseAggregatorDtoPage
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICarrierConfigResponseAggregatorDtoPage interface.
 */
export function instanceOfICarrierConfigResponseAggregatorDtoPage(value: object): value is ICarrierConfigResponseAggregatorDtoPage {
    return true;
}

export function ICarrierConfigResponseAggregatorDtoPageFromJSON(json: any): ICarrierConfigResponseAggregatorDtoPage {
    return ICarrierConfigResponseAggregatorDtoPageFromJSONTyped(json, false);
}

export function ICarrierConfigResponseAggregatorDtoPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICarrierConfigResponseAggregatorDtoPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ICarrierConfigResponseAggregatorDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICarrierConfigResponseAggregatorDtoPageToJSON(json: any): ICarrierConfigResponseAggregatorDtoPage {
    return ICarrierConfigResponseAggregatorDtoPageToJSONTyped(json, false);
}

export function ICarrierConfigResponseAggregatorDtoPageToJSONTyped(value?: ICarrierConfigResponseAggregatorDtoPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ICarrierConfigResponseAggregatorDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

